import type { ReactNode } from 'react'

import type { AccountSection } from './detailScope'
import { StatementLink } from './StatementLink'

interface AccountHeadingProps {
  section: AccountSection
  // Hidden when one account is chosen: the selector already names it.
  showName: boolean
  // Figures that sit before the statement link, such as "Printed total $2,030,351.88".
  summary?: ReactNode
  // Said in place of the statement link when the month has no statement.
  gapSentence?: string
}

// One account's group head: the name and type, then the summary and the statement link at the right.
export const AccountHeading = ({
  section,
  showName,
  summary,
  gapSentence,
}: AccountHeadingProps) => {
  const { account } = section
  const statement = account.statement
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
      {showName ? (
        <p className="flex items-baseline gap-2.5">
          <span className="text-sm font-semibold">{account.name}</span>
          <span className="text-sm text-ink-subtle">{account.accountType}</span>
        </p>
      ) : (
        <span />
      )}
      <div className="flex items-baseline gap-2 whitespace-nowrap">
        {summary}
        {summary && statement && <span className="text-blue-4">·</span>}
        {statement ? (
          <StatementLink
            month={statement.month}
            fileUrl={statement.statementFileUrl}
            fileName={statement.statementFileName}
          />
        ) : (
          gapSentence && (
            <span className="text-sm text-ink-subtle">{gapSentence}</span>
          )
        )}
      </div>
    </div>
  )
}
